import { render, staticRenderFns } from "./ExpedientLastActionsWidget.vue?vue&type=template&id=eb2e0836&scoped=true"
import script from "./ExpedientLastActionsWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpedientLastActionsWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExpedientLastActionsWidget.vue?vue&type=style&index=0&id=eb2e0836&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2e0836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb2e0836')) {
      api.createRecord('eb2e0836', component.options)
    } else {
      api.reload('eb2e0836', component.options)
    }
    module.hot.accept("./ExpedientLastActionsWidget.vue?vue&type=template&id=eb2e0836&scoped=true", function () {
      api.rerender('eb2e0836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientLastActions/ExpedientLastActionsWidget.vue"
export default component.exports